module.exports = __webpack_public_path__ + "img/url_icon.ffdd7b3e.png";